import React from 'react';
import PropTypes from 'prop-types';

import MuiList from '@material-ui/core/List';
import ListItem from 'components/molecules/Listitem/ListItem';

/**
 * List component based on https://material-ui.com/components/lists/#lists
 * @param {*} props All props can be found in docs https://material-ui.com/api/list/
 */
export default function List(props) {
  const { children, type, ...rest } = props;

  return (
    <MuiList component={type} {...rest}>
      {children &&
        children.map((text, index) => {
          return (
            <ListItem index={type === 'ol' ? index + 1 : undefined}>
              {text}
            </ListItem>
          );
        })}
    </MuiList>
  );
}

List.propTypes = {
  /**
   * Array of text list items.
   */
  children: PropTypes.node,
  /**
   * Ordered ('ol') or unordered ('ul) list.
   */
  type: PropTypes.string,
};
